module.exports = __webpack_public_path__ + "static/world2-16529dc1a52d9288a0b55b00e6106ecb.jpg";